export const scaleColors = [
    "#00876c",
    "#439981",
    "#6aaa96",
    "#8cbcac",
    "#aecdc2",
    "#cfdfd9",
    "#f1f1f1",
].reverse()